import React from "react";

import { useState, useEffect } from "react";

import { useParams } from "react-router-dom";

import axios from 'axios';

import '../Routes/Coin.scss';

import DOMPurify from "dompurify";

const Coin = () => {
    const params = useParams();
    const [coin, setCoin] = useState([]);
    const url = `https://api.coingecko.com/api/v3/coins/${params.coinId}`;

    useEffect(()=>{
        axios.get(url).then((response)=> {
            setCoin(response.data);
        }).catch((error) => {
            console.log(error);
        });

    }, [])

    return (
        <div>
            <div className="coinBase">
                <div className="coin-info">
                    {coin.image ? <img src={coin.image.small} alt="" /> : null}
                    <h1>{coin.name}</h1>
                    {coin.symbol ? <p>{coin.symbol.toUpperCase()}</p> : null}
                </div>
                <div className="coin-info">
                    <div className="coin-rank">
                        <span className="coin-rank-btn">Rank # {coin.market_cap_rank}</span>
                        {coin.market_data ?. current_price ? <h1>${parseInt(coin.market_data.current_price.usd).toLocaleString()}</h1> : null}
                    </div>
                </div>
                <div className="coin-info">
                    <table >
                        <thead>
                            <tr>
                                <th>1h</th>
                                <th>24h</th>
                                <th>7d</th>
                                <th>14d</th>
                                <th className="hide-mobile">30d</th>
                                <th className="hide-mobile">1yr</th>
                            </tr>                                                      
                       
                        </thead>
                        <tbody>
                            <tr>
                                <td>{coin.market_data?.price_change_percentage_1h_in_currency ? <p>{coin.market_data.price_change_percentage_1h_in_currency.usd.toFixed(3)}%</p> : null}</td>
                                <td>{coin.market_data?.price_change_percentage_24h_in_currency?<p>{coin.market_data.price_change_percentage_24h_in_currency.usd.toFixed(3)}%</p> : null}</td>
                                <td>{coin.market_data?.price_change_percentage_7d_in_currency?<p>{coin.market_data.price_change_percentage_7d_in_currency.usd.toFixed(3)}%</p> : null}</td>
                                <td>{coin.market_data?.price_change_percentage_14d_in_currency?<p>{coin.market_data.price_change_percentage_14d_in_currency.usd.toFixed(3)}%</p> : null}</td>
                                <td className="hide-mobile">{coin.market_data?.price_change_percentage_30d_in_currency?<p>{coin.market_data.price_change_percentage_30d_in_currency.usd.toFixed(3)}%</p> : null}</td>
                                <td className="hide-mobile">{coin.market_data?.price_change_percentage_1y_in_currency?<p>{coin.market_data.price_change_percentage_1y_in_currency.usd.toFixed(3)}%</p> : null}</td>
                            </tr>   

                        </tbody>
                    </table>
                </div>
                <div className="coin-info">
                    <div className="coin-stats">
                        <div className="left">
                            <div className="coin-t">
                                <h4>24 Hour Low</h4>
                                {coin.market_data?.low_24h ? <p>${coin.market_data.low_24h.usd.toLocaleString()}</p> : null}
                                
                            </div>
                            <div className="coin-t">
                                <h4>24 Hour High</h4>
                                {coin.market_data?.high_24h ? <p>${coin.market_data.high_24h.usd.toLocaleString()}</p> : null}
                                
                            </div>
                            <div className="coin-t">
                                <h4>Marketing Cap</h4>
                                {coin.market_data?.market_cap ? <p>${coin.market_data.market_cap.usd.toLocaleString()}</p> : null}                                
                            </div>
                            <div className="coin-t">
                                <h4>Circulating Supply</h4>
                                {coin.market_data ? <p>{coin.market_data.circulating_supply.toLocaleString()}</p> : null}    
                                
                            </div>
                        </div>
                      
                    </div>
                </div>
                <div className="coin-info">
                    <div className="coin-about">
                        <h4>About</h4>
                        <p dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(coin.description ? coin.description.en : '')
                        }}></p>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Coin;